import React from 'react'

export const MatxLayouts: any = {
  layout1: React.lazy(() => import('./Layout1/Layout1')),
}
